import React from 'react';
import { Zap, Target, Lightbulb } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Zap,
      title: 'Criatividade',
      description: 'Ideias inovadoras que transformam conteúdo em experiências memoráveis',
    },
    {
      icon: Target,
      title: 'Qualidade',
      description: 'Equipamentos profissionais e equipe especializada para resultados impecáveis',
    },
    {
      icon: Lightbulb,
      title: 'Estratégia',
      description: 'Soluções integradas que potencializam o alcance do seu conteúdo',
    },
  ];

  return (
    <section id="quem-somos" className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Quem Somos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Mais que um estúdio,
            <br />
            um <span className="text-[#ff6b35]">ecossistema criativo</span>
          </h2>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6 text-center md:text-left">
            <div className="prose prose-lg max-w-none mx-auto">
              <p className="text-gray-700 leading-relaxed text-lg">
                O <strong className="text-[#1e3a5f]">Estúdio Hertz</strong> é mais do que um estúdio de produção. Somos um ecossistema de criação, onde ideias ganham forma, som e impacto.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                O <strong className="text-[#1e3a5f]">Hertz</strong> é o ponto de convergência entre produção musical, audiovisual, podcasts, jingles, vinhetas, gravação de cursos, transmissões ao vivo e suporte para lançamentos.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                Aqui, cada elemento se conecta para potencializar o conteúdo dos nossos clientes, transformando conhecimento e criatividade em resultados reais.
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6">
            {[
              { number: '5000+', label: 'Projetos Realizados' },
              { number: '25+', label: 'Anos de Experiência' },
              { number: '100%', label: 'Satisfação' },
              { number: '24/7', label: 'Suporte' },
            ].map((stat, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100"
              >
                <div className="text-3xl md:text-4xl font-bold text-[#ff6b35] mb-2">{stat.number}</div>
                <div className="text-[#1e3a5f] font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#ff6b35]/30 overflow-hidden"
            >
              {/* Background decoration */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#48a9a6]/10 to-transparent rounded-bl-full transform translate-x-8 -translate-y-8 group-hover:scale-150 transition-transform duration-500"></div>
              
              <div className="relative z-10">
                <div className="w-14 h-14 bg-gradient-to-br from-[#ff6b35] to-[#ff8555] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <value.icon className="text-white" size={28} />
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-3">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;